import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1bdca5e5&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bdca5e5"]])

export default __exports__